<template>
    <div>
        <v-container>
            <v-card>
                <v-card-title>Welcome!</v-card-title>
                <v-card-text>
                    You have {{ incompleteTasks.length }} incomplete tasks.
                    <span v-if="roleType == 'regular'">
                        Each task will automatically use the number of action points.
                        You have <b>{{ actionPoints }} action points left</b> for today.
                    </span>
                </v-card-text>
            </v-card>
        </v-container>

        <v-container>
            <div id="tasks">
                <v-list>
                    <v-list-item v-for="(task, i) in tasks" three-line :key="i" @click="task.actionPoints || task.actionPoints == 0 ? completeTask(task) : null">
                        <v-list-item-icon>
                            <v-icon v-text="task.complete ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'"></v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title :class="{'complete': task.complete}">{{ task.title }}</v-list-item-title>
                            <v-list-item-subtitle>
                                {{ task.complete ? "Complete" : "Incomplete" }}
                                &#9679;
                                Requires {{ taskActionPoints(task) }} action points <span v-if="extraActionPoints(task) > 0" class="red--text">(plus {{ extraActionPoints(task) }} extra)</span>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                <span v-if="task.action && !task.complete"><b>Complete by doing {{ getAction(task.action).title }} in your role app.</b></span>
                                <span v-if="task.description"> {{ task.description }}</span>
                                <span> Added on day {{ task.showDay }}.</span>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle v-if="task.penalty || extraActionPoints(task) > 0" class="red--text" style="font-style: italic">
                                <span v-if="task.penalty">You have accepted this task from someone else. </span>
                                <span v-if="extraActionPoints(task) > 0">This task will cost you an extra {{ extraActionPoints(task) }} AP.</span>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </div>
        </v-container>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { slugify } from '../util';

export default {
    name: "Todo",
    data: () => ({
        currentTask: null
    }),
    computed: {
        incompleteTasks() {
            return Object.values(this.tasks).filter(t => t.complete == false);
        },
        ...mapState({
            tasks: state => state.tasks,
            actionPoints: state => state.actionPoints,
            roleActions: state => state.role?.additionalActions || [],
            rawAssemblies: state => state.assemblies
        }),
        roleType() {
            return (this.$store.state.role ? this.$store.state.role.type : 'regular') || 'regular';
        }
    },
    methods: {
        ...mapActions(["completeTask"]),
        extraActionPoints(task) {
            const regularActionPoints = this.taskActionPoints(task);
            const penaltyActionPoints = regularActionPoints * task.penalty;
            return penaltyActionPoints - regularActionPoints;
        },
        taskActionPoints(task) {
            if (task.actionPoints || task.actionPoints == 0) {
                return task.actionPoints;
            } else if (task.action == "meeting") {
                return task.length || 1;
            } else if (task.action) {
                return this.getAction(task.action).actionPoints;
            } else {
                return "?";
            }
        },
        getAction(actionSlug) {
            if (actionSlug == 'paperwork') {
                return {
                    title: "Paperwork",
                    actionPoints: 1
                }
            } else if (actionSlug == 'training') {
                return {
                    title: "Training",
                    actionPoints: 1
                }
            } else if (actionSlug == 'meeting') {
                return {
                    title: "Meeting",
                    actionPoints: 1
                }
            } else {
                for (const action of this.roleActions) {
                    const slug = slugify(action.title);

                    if (slug == actionSlug) {
                        return action;
                    }
                }

                return {
                    title: actionSlug,
                    actionPoints: "?"
                }
            }
        }
    }
}
</script>

<style scoped>
    .complete {
        text-decoration: line-through;
    }
</style>
